module.exports = __webpack_public_path__ + "files/0bb727bb7664d8fa0b14a1d59c3a08e9.png";